import { Text, Tooltip } from "components";
import { AnimalTagOwnership } from "generated/graphql";
import TagIcon from "../TagIcon";
import TagLocalIcon from "../TagLocalIcon";

import styles from "./Tag.module.scss";

export interface TagItem {
  tagId: string | undefined;
  name: string;
  color: string;
  ownership?: AnimalTagOwnership | string;
}

export const Tag = ({ tag }: { tag: TagItem }) => {
  return (
    <div key={tag.tagId} className={styles["animals_list__tag_icon_wrapper"]}>
      <Tooltip visualIndicator={true} title={tag.name} placement="top">
        {tag.ownership === AnimalTagOwnership.System ? (
          <>
            <TagIcon fill={tag.color} />
            <Text className={styles["animals_list__tag_icon_text"]} smaller>
              {tag.name.slice(0, 1).toUpperCase()}
            </Text>
          </>
        ) : (
          <TagLocalIcon fill={tag.color} />
        )}
      </Tooltip>
    </div>
  );
};
